import { render } from "./winlose.vue?vue&type=template&id=6d4dc322&scoped=true"
import script from "./winlose.vue?vue&type=script&lang=js"
export * from "./winlose.vue?vue&type=script&lang=js"

import "./winlose.vue?vue&type=style&index=0&id=6d4dc322&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4dc322"]])

export default __exports__